import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";
import { WhySection } from "@/components/home/WhySection";
import { WhoWeWorkWithSection } from "@/components/home/WhoWeWorkWithSection";
import { WhatWeDoSection } from "@/components/home/WhatWeDoSection";
import { PhilosophySection } from "@/components/home/PhilosophySection";
import { ProofSection } from "@/components/home/ProofSection";
import { FinalCTASection } from "@/components/home/FinalCTASection";

const Index = () => {
  return (
    <Layout>
      <HeroSection />
      <WhySection />
      <WhoWeWorkWithSection />
      <WhatWeDoSection />
      <PhilosophySection />
      <ProofSection />
      <FinalCTASection />
    </Layout>
  );
};

export default Index;
